module.exports = __webpack_public_path__ + "img/11.f35b4c02.png";